import axios from "axios";
import { useAuthStore } from "../store/authStore";

const API_URL = import.meta.env.VITE_API_URL || "https://tv-central.lukamoari.workers.dev";

export const api = axios.create({
  baseURL: API_URL,
  timeout: 30000,
});

// Inyecta el JWT en cada request
api.interceptors.request.use((cfg) => {
  const token = useAuthStore.getState().token;
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Si recibe 401, limpia auth y manda a /login con un flag para que la
// pantalla de login muestre "Tu sesión expiró" en vez de aparecer de la nada.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const wasLoggedIn = !!useAuthStore.getState().token;
      useAuthStore.getState().logout();
      if (typeof window !== "undefined" && window.location.pathname !== "/login") {
        if (wasLoggedIn) sessionStorage.setItem("tv_session_expired", "1");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
